export const defaultImportSettings = {
  productIdFieldName: "",
  titleFieldName: "",
  hasParentProduct: false,
  usePreezieGeneratedId: false,
  useAggregationValueAsDocumentId: false,
  rules: [],
};

export const normalizeImportSettings = (settings) => ({
  ...defaultImportSettings,
  ...(settings || {}),
  usePreezieGeneratedId:
    settings?.usePreezieGeneratedId ?? settings?.UsePreezieGeneratedId ?? false,
  useAggregationValueAsDocumentId:
    settings?.useAggregationValueAsDocumentId ??
    settings?.UseAggregationValueAsDocumentId ??
    false,
});

export const buildImportSettingsPayload = (settings) => ({
  ProductIdFieldName: settings?.productIdFieldName || "",
  TitleFieldName: settings?.titleFieldName || "",
  HasParentProduct: settings?.hasParentProduct || false,
  UsePreezieGeneratedId: settings?.usePreezieGeneratedId || false,
  UseAggregationValueAsDocumentId:
    settings?.useAggregationValueAsDocumentId || false,
  Rules: (settings?.rules || []).map(({ targetField, ...rule }) => rule),
});
